import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const QrIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M0 7.11111H1.77778V8.88889H0V7.11111ZM7.11111 1.77778H8.88889V5.33333H7.11111V1.77778ZM5.33333 7.11111H8.88889V10.6667H7.11111V8.88889H5.33333V7.11111ZM10.6667 7.11111H12.4444V8.88889H14.2222V7.11111H16V8.88889H14.2222V10.6667H16V14.2222H14.2222V16H12.4444V14.2222H8.88889V16H7.11111V12.4444H10.6667V10.6667H12.4444V8.88889H10.6667V7.11111ZM14.2222 14.2222V10.6667H12.4444V14.2222H14.2222ZM10.6667 0H16V5.33333H10.6667V0ZM12.4444 1.77778V3.55556H14.2222V1.77778H12.4444ZM0 0H5.33333V5.33333H0V0ZM1.77778 1.77778V3.55556H3.55556V1.77778H1.77778ZM0 10.6667H5.33333V16H0V10.6667ZM1.77778 12.4444V14.2222H3.55556V12.4444H1.77778Z" fill={color} />
  </Svg>
);

QrIcon.displayName = 'QrIcon';
